import { Button } from 'modules/v2/common/AtomicDesign/atoms';
import { Navbar } from 'modules/v2/editor/templates/EditorTemplate/components';
import { useEffect, useState } from 'react';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
import { trackUsage } from 'modules/v2/common/utils/trackUsage';

import { DesignHuddleProvider, useDesignHuddle } from './DesignHuddleContext';

const isOnEditorPage = () => {
  return window.location.href.includes('/templates/create/') || window.location.href.includes('/templates/project/');
};

const GoBackButton = () => {
  const history = useHistory();

  return (
    <Button
      type="outlined"
      size="base"
      color='black'
      className=""
      onClick={() => history.push('/dashboard/templates/my-projects')}
    >
      <>
        <ArrowLeftOutlined/>
        <span className='ml-4'>My Projects</span>
      </>
    </Button>
  );
};
const ExportButton = () => {
  const { isExportReady } = useDesignHuddle();

  const handleClick = () => {
    // Track export button click in Datadog
    trackUsage('template-builder', 'export', {
      page: 'TemplatesBuilderEditor',
    });

    const event = new CustomEvent('show-export-template');
    window.dispatchEvent(event);
  };

  if (isOnEditorPage()) {
    return (
      <Button
        type="primary"
        size="base"
        className=""
        disabled={!isExportReady}
        onClick={handleClick}
      >
        Export
      </Button>
    );
  }

  return <></>;
};

export default function DesignHuddleLayout({ children }) {
  useEffect(() => {
    const rootContainer = document.getElementById('root-body');
    rootContainer.setAttribute('style', 'overflow: auto;');
  }, []);

  return (
    <DesignHuddleProvider>
      <div className="min-h-screen flex flex-col">
        <div className="flex-shrink-0">
          <Navbar
            rightItems={[
              <GoBackButton />,
            ]}
            leftItems={[
              <ExportButton />,
            ]}
          />
        </div>

        <div className="flex-1 overflow-auto">
          {children}
        </div>
      </div>
    </DesignHuddleProvider>
  );
}
